module.exports = __webpack_public_path__ + "static/media/zeus1.a4fb4dd5.png";